import { render, staticRenderFns } from "./PersonalNotificationsPanel.vue?vue&type=template&id=a59bcac8"
import script from "./PersonalNotificationsPanel.vue?vue&type=script&lang=js"
export * from "./PersonalNotificationsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports